import { render, staticRenderFns } from "./BranchForm.vue?vue&type=template&id=ca2f764e&scoped=true&"
import script from "./BranchForm.vue?vue&type=script&lang=js&"
export * from "./BranchForm.vue?vue&type=script&lang=js&"
import style0 from "./BranchForm.vue?vue&type=style&index=0&id=ca2f764e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2f764e",
  null
  
)

export default component.exports